import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

const modifiers = {
  large: ({ theme }) => ({
    styles: `
      font-size: ${theme.body.large};
    `,
  }),
  small: ({ theme }) => ({
    styles: `
      font-size: ${theme.body.small};
    `,
  }),
  micro: ({ theme }) => ({
    styles: `
      font-size: ${theme.body.micro};
    `,
  }),
  inverted: () => ({
    styles: `
      color: white;
    `,
  }),
};

export const TextStyled = styled.p.attrs({
  className: 'component__text',
})`
  letter-spacing: 0.08px;
  line-height: 1.2rem;
  color: #333333;
  margin: 0;
  font-family: ${(props) => props.theme.fontFamily};
  font-size: ${(props) => props.theme.body.medium};
  ${applyStyleModifiers(modifiers)};
`;
